// extracted by mini-css-extract-plugin
module.exports = {"container":"as","topReviewHeading":"bs","criticalReview":"cs","favorableReview":"ds","vsSeparator":"es"};